module.exports = "/assets/data/7431cd01d1c817229e5180e54de2ed7d-DE72.data.json";